import Api from "../config/Axios";

const config = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("token"),
    UserId: localStorage.getItem("user_id"),
  },
};

export const createshift = (data) => {
  return Api.post("api/dashboard/batch/create", data, { config });
};

// const zoneid = "62f0d9aac9bb445efc60cbbd";
// export const getshiftList = () => {
//   return Api.get(`api/web/shift/list-by-zone/${zoneid}`);
// };
const zoneid = "62f0d9aac9bb445efc60cbbd";

// export const getshiftList = () => {
//   return Api.get("api/web/shift/find-upcoming");
// };

export const getshiftList = () => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };

  return Api.get("api/web/shift/list", config);
};

// function objToQueryString(obj) {
//   const keyValuePairs = [];
//   for (const key in obj) {
//     keyValuePairs.push(
//       encodeURIComponent(key) + "=" + encodeURIComponent(obj[key])
//     );
//   }
//   return keyValuePairs.join("&");
// }

export const getShiftsFiltersPagination = (data, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get(`api/web/shift/list?${objToQueryString(data)}`, config);
};

export const getSingleShift = (shiftId, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get(`api/web/shift/detail/${shiftId}`, config);
};

export const shiftAdd = (data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  return Api.post("api/web/shift/create", data, config);
};

export const shiftEdit = (data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  return Api.patch("api/web/shift/update", data, config);
};

export const shiftActive = (data, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.patch("api/web/shift/activate", data, config);
};

export const shiftInActive = (data, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.patch("api/web/shift/deactivate", data, config);
};

export const bulkShiftAdd = (data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  return Api.post("api/web/shift/createMany", data, config);
};

function objToQueryString(obj) {
  const keyValuePairs = [];
  for (const key in obj) {
    keyValuePairs.push(
      encodeURIComponent(key) + "=" + encodeURIComponent(obj[key])
    );
  }
  return keyValuePairs.join("&");
}

export const getSingleShiftRiders = (shiftId, data, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get(`api/web/shift/riders/${shiftId}?${objToQueryString(data)}`,config);
};

export const riderShiftRemove = (riderShiftId, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.patch("api/web/shift/remove-rider", riderShiftId, config);
};

export const RiderReAssignShift = (data, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.post("api/web/shift/assign-rider", data, config);
};

export const getShiftTypes = (token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get(`api/web/shift/types`,config);
};
